import { gql } from '@apollo/client';

export const GET_MY_PROFILE = gql`
  query GetMyProfile {
    getMyProfile {
      id
      userId
      displayName
      email
      photoUrl
      recommendationsEnabled
      defaultSharingPermission
      shareByEmail
      externalSharingPreferences {
        shareHighlights { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
        insightRecaps { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
      }
      updatedAt
    }
  }
`;

export const UPDATE_MY_PROFILE = gql`
  mutation UpdateMyProfile($input: UserProfileInput!) {
    updateMyProfile(input: $input) {
      id
      userId
      displayName
      email
      photoUrl
      recommendationsEnabled
      defaultSharingPermission
      shareByEmail
      externalSharingPreferences {
        shareHighlights { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
        insightRecaps { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
      }
      updatedAt
    }
  }
`;

export const UPLOAD_PROFILE_PHOTO = gql`
  mutation UploadProfilePhoto($input: ProfilePhotoUploadInput!) {
    uploadProfilePhoto(input: $input) {
      id
      userId
      displayName
      email
      photoUrl
      recommendationsEnabled
      defaultSharingPermission
      shareByEmail
      externalSharingPreferences {
        shareHighlights { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
        insightRecaps { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
      }
      updatedAt
    }
  }
`;

export const REMOVE_PROFILE_PHOTO = gql`
  mutation RemoveProfilePhoto {
    removeProfilePhoto {
      id
      userId
      displayName
      email
      photoUrl
      recommendationsEnabled
      defaultSharingPermission
      shareByEmail
      externalSharingPreferences {
        shareHighlights { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
        insightRecaps { showDisplayName useEntryPhotos includeReviews includeRatings showExactDates showPlaceNames includeDetailedMetrics }
      }
      updatedAt
    }
  }
`;

const SUBSCRIPTION_STATUS_FIELDS = gql`
  fragment SubscriptionStatusFields on SubscriptionStatus {
    plan
    planId
    planKind
    billingCycle
    hobbyIds
    status
    entitlement
    trialStartedAt
    trialEndsAt
    currentPeriodStartedAt
    currentPeriodEndsAt
    provider
    providerCustomerId
    providerSubscriptionId
    cancelAtPeriodEnd
    currentAmount
    currentPrice
    currency
    selectionChangeAvailableAt
    pendingChange {
      planKind
      billingCycle
      hobbyIds
      effectiveAt
      amount
      price
      currency
    }
    entitlements {
      hobby
      label
      entitlement
    }
    limits {
      hobby
      label
      used
      limit
      remaining
      unlimited
    }
    freeUsage { used limit remaining }
    availablePlans {
      id
      planKind
      billingCycle
      price
      amount
      currency
      popular
    }
  }
`;

export const GET_MY_SUBSCRIPTION_STATUS = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  query GetMySubscriptionStatus {
    getMySubscriptionStatus {
      ...SubscriptionStatusFields
    }
  }
`;

export const START_PREMIUM_TRIAL = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  mutation StartPremiumTrial {
    startPremiumTrial {
      ...SubscriptionStatusFields
    }
  }
`;

export const CREATE_CHECKOUT_SESSION = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  mutation CreateCheckoutSession($input: CheckoutSessionInput) {
    createCheckoutSession(input: $input) {
      checkoutUrl
      provider
      subscriptionStatus {
        ...SubscriptionStatusFields
      }
    }
  }
`;

export const CHANGE_SUBSCRIPTION = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  mutation ChangeSubscription($input: SubscriptionChangeInput!) {
    changeSubscription(input: $input) {
      ...SubscriptionStatusFields
    }
  }
`;

export const CANCEL_PENDING_SUBSCRIPTION_CHANGE = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  mutation CancelPendingSubscriptionChange {
    cancelPendingSubscriptionChange {
      ...SubscriptionStatusFields
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  mutation CancelSubscription {
    cancelSubscription {
      ...SubscriptionStatusFields
    }
  }
`;

export const RESUME_SUBSCRIPTION = gql`
  ${SUBSCRIPTION_STATUS_FIELDS}
  mutation ResumeSubscription {
    resumeSubscription {
      ...SubscriptionStatusFields
    }
  }
`;
